"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.index-of.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactLoadingIndicator = _interopRequireDefault(require("react-loading-indicator"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
var _InputError = _interopRequireDefault(require("./InputError"));
var _excluded = ["disable", "type", "children", "error"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var checkForButtonType = function checkForButtonType(props, name) {
  return props[name] || props.buttonStyle === name;
};
var study_manager_styles = "\n  width: auto;\n  padding: ".concat(function (props) {
  return props.isLoading ? "8px 12px 8px 45px" : "8px 12px 8px 14px";
}, ";\n  font-size: ").concat(14 / 16, "rem;\n  border-radius: 2px;\n  color: #111;\n  height: auto;\n  background: #FFF;\n  border: 1px solid #D8D8D8;\n\n  &:active {\n    background: #EFF6F7;\n    border: 1px solid #EFF6F7;\n  }\n\n  &:disabled {\n    background: #EFF6F7;\n    border: 1px solid #EFF6F7;\n    cursor: default !important;\n\n    &:hover {\n      background: #EFF6F7;\n      border: 1px solid #EFF6F7;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n    background: #EFF6F7;\n    border: 1px solid #EFF6F7;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n");
var NewButton = _styledComponents["default"].button.withConfig({
  displayName: "Button__NewButton"
})(["width:100%;font-size:1rem;padding:13px 16px;position:relative;border-radius:3px;color:#fff;cursor:pointer;&:disabled{&:hover{cursor:default !important;}}", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], function (props) {
  return (
    // PRIMARY
    checkForButtonType(props, "primary") && (0, _styledComponents.css)(["background:linear-gradient(-180deg,#0d5875 0%,#0c4e69 100%);border:1px solid #083245;&:active{background:linear-gradient(0deg,#0c526e 0%,#0c4e69 100%);}&:disabled{color:#3e83a0;background:linear-gradient(-180deg,#0c526e 0%,#0b4861 100%);}&:hover{cursor:pointer;background:linear-gradient(-180deg,#0c526e 0%,#0b4861 100%);}"])
  );
}, function (props) {
  return (
    // transparent
    checkForButtonType(props, "transparent") && (0, _styledComponents.css)(["background:transparent;color:#111;border:1px solid transparent;&:active{background:linear-gradient(0deg,#ffffff 0%,#fcfcfc 100%);}&:disabled{color:#b3b3b3;background:linear-gradient(-180deg,#f7f7f7 0%,#f5f5f5 100%);},&:hover{cursor:pointer;background:linear-gradient(-180deg,#f7f7f7 0%,#f5f5f5 100%);}"])
  );
}, function (props) {
  return (
    // secondary
    checkForButtonType(props, "secondary") && (0, _styledComponents.css)(["background:linear-gradient(-180deg,#ffffff 0%,#fcfcfc 100%);color:#111;border:1px solid #e3e3e3;&:active{background:linear-gradient(0deg,#ffffff 0%,#fcfcfc 100%);}&:disabled{color:#b3b3b3;background:linear-gradient(-180deg,#f7f7f7 0%,#f5f5f5 100%);}&:hover{cursor:pointer;background:linear-gradient(-180deg,#f7f7f7 0%,#f5f5f5 100%);}"])
  );
}, function (props) {
  return (
    // warning
    checkForButtonType(props, "warning") && (0, _styledComponents.css)(["background:linear-gradient(-180deg,#e11f1f 0%,#d91e1e 100%);border:1px solid #c71c1c;&:active{background:linear-gradient(0deg,#e11f1f 0%,#d91e1e 100%);}&:disabled{color:#ff7070;background:linear-gradient(-180deg,#d91e1e 0%,#d11d1d 100%);}&:hover{cursor:pointer;background:linear-gradient(-180deg,#d91e1e 0%,#d11d1d 100%);}"])
  );
}, function (props) {
  return (
    // confirm
    checkForButtonType(props, "confirm") && (0, _styledComponents.css)(["background:linear-gradient(-180deg,#28b90c 0%,#27b30b 100%);border:1px solid #23a30a;&:active{background:linear-gradient(0deg,#27b30b 0%,#25ab0a 100%);}&:disabled{color:#8fdb7f;background:linear-gradient(-180deg,#27b30b 0%,#25ab0a 100%);}&:hover{cursor:pointer;background:linear-gradient(-180deg,#27b30b 0%,#25ab0a 100%);}"])
  );
}, function (props) {
  return (
    // default
    checkForButtonType(props, "default") && (0, _styledComponents.css)(["background:linear-gradient(-180deg,#07242e 0%,#051a21 100%);border:1px solid #031014;&:active{background:linear-gradient(0deg,#051a21 0%,#07242e 100%);}&:disabled{color:#828f93;background:linear-gradient(-180deg,#082833 0%,#061e26 100%);}&:hover{cursor:pointer;background:linear-gradient(-180deg,#082833 0%,#061e26 100%);}"])
  );
}, function (props) {
  return (
    // pink
    checkForButtonType(props, "pink") && (0, _styledComponents.css)(["background:linear-gradient(-180deg,#f74595 0%,#ef4490 100%);border:1px solid #db3d84;&:active{background:linear-gradient(0deg,#f74595 0%,#ef4490 100%);}&:disabled{color:#f5a3c7;background:linear-gradient(-180deg,#ff57a2 0%,#fa4697 100%);}&:hover{cursor:pointer;background:linear-gradient(-180deg,#ff57a2 0%,#fa4697 100%);}"])
  );
}, function (props) {
  return (
    // lightblue
    checkForButtonType(props, "lightblue") && (0, _styledComponents.css)(["background:linear-gradient(-180deg,#00a6d7 0%,#00a6d7 100%);border:1px solid #007095;transition:background-color 300ms ease-out;&:active{background:linear-gradient(0deg,#007095 0%,#007095 100%);}&:disabled{color:#6fd7f7;background:linear-gradient(-180deg,#007095 0%,#007095 100%);},&:hover{cursor:pointer;background:linear-gradient(-180deg,#007095 0%,#007095 100%);}"])
  );
}, function (props) {
  return (
    // flatprimary
    checkForButtonType(props, "flatprimary") && (0, _styledComponents.css)(["background:#0b3a4d;border:1px solid #dbdbdb;&:active{background:#0b3a4d;}&:disabled{background:#0b3a4d;cursor:default !important;&:hover{background:#0b3a4d;}}&:hover{cursor:pointer;background:#0b3a4d;}"])
  );
}, function (props) {
  return (
    // achievement
    checkForButtonType(props, "achievement") && (0, _styledComponents.css)(["font-family:'Heebo',Helvetica,Arial,sans-serif;font-weight:500;text-transform:uppercase;height:60px;background:#0652b6;border:0;&:active{background:#0b304d;}&:disabled{color:#7d7e7f;background:#e6e6e6;cursor:default !important;&:hover{background:#e6e6e6;}}&:hover{cursor:pointer;background:#0c4384;boxshadow:0 2 4px 0 #0b304d;}&:focus{outline:0;}"])
  );
}, function (props) {
  return (
    // achievement_text
    checkForButtonType(props, "achievement_text") && (0, _styledComponents.css)(["font-family:'Karla',Helvetica,Arial,sans-serif;font-weight:500;color:#06466d;text-transform:uppercase;height:60px;background:transparent;border:0;&:active{background:rgba(6,70,109,0.12);}&:disabled{color:#7d7e7f;background:transparent;cursor:default !important;&:hover{background:transparent;}}&:hover{cursor:pointer;background:rgba(6,70,109,0.12);}&:focus{outline:0;}"])
  );
}, function (props) {
  return (
    // sm_primary
    checkForButtonType(props, "sm_primary") && (0, _styledComponents.css)(["", ";color:#fff;background:#00bbd5;border:1px solid #d8d8d8;&:active{background:#60b7c3;border:1px solid #60b7c3;}&:disabled{background:#60b7c3;border:1px solid #60b7c3;&:hover{background:#60b7c3;border:1px solid #60b7c3;}}&:hover{background:#60b7c3;border:1px solid #60b7c3;}"], function (props) {
      return study_manager_styles;
    })
  );
}, function (props) {
  return (
    // sm_warning
    checkForButtonType(props, "sm_warning") && (0, _styledComponents.css)(["", ";color:#fff;background:#d52c00;border:1px solid #d8d8d8;&:active{background:#ee471c;border:1px solid #ee471c;}&:disabled{background:#ee471c;border:1px solid #ee471c;&:hover{background:#ee471c;border:1px solid #ee471c;}}&:hover{background:#ee471c;border:1px solid #ee471c;}"], function (props) {
      return study_manager_styles;
    })
  );
}, function (props) {
  return (
    // sm_default
    checkForButtonType(props, "sm_default") && (0, _styledComponents.css)(["", ";color:#111;"], function (props) {
      return study_manager_styles;
    })
  );
}, function (props) {
  return (
    // sm_default_blue
    checkForButtonType(props, "sm_default_blue") && (0, _styledComponents.css)(["", ";background:#fff;border-color:#2e6aff;color:#2e6aff;&:active{box-shadow:inset 0px 0px 0px 1px #2e6aff;background:#fff;}&:hover{cursor:pointer;background:#f2f3f4;border:1px solid #336bfe;background:#f2f3f4;}"], function (props) {
      return study_manager_styles;
    })
  );
});
var getLoadingColor = function getLoadingColor(style) {
  if (["secondary", "sm_default"].indexOf(style) !== -1) {
    //
    //
    // black loader
    return {
      red: 0,
      green: 0,
      blue: 0,
      alpha: 1
    };
  } else if (["achievement_text"].indexOf(style) !== -1) {
    //
    //
    // Blue Loader
    return {
      red: 6,
      green: 70,
      blue: 109,
      alpha: 1
    };
  }
  return {
    red: 255,
    green: 255,
    blue: 255,
    alpha: 1
  };
};
var Loading = (0, _styledComponents["default"])(_reactLoadingIndicator["default"]).withConfig({
  displayName: "Button__Loading"
})(["position:absolute;top:auto;bottom:auto;left:15px;"]);
var Button = function Button(_ref) {
  var disable = _ref.disable,
    type = _ref.type,
    children = _ref.children,
    error = _ref.error,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(NewButton, (0, _extends2["default"])({
    type: type,
    disabled: disable
  }, rest), rest.isLoading && /*#__PURE__*/_react["default"].createElement(Loading, {
    color: getLoadingColor(rest.buttonStyle)
  }), children), error.length !== 0 && /*#__PURE__*/_react["default"].createElement(_InputError["default"], null, error));
};
Button.propTypes = {
  onClick: _propTypes["default"].func,
  isLoading: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  disable: _propTypes["default"].bool,
  buttonStyle: _propTypes["default"].oneOf(_constants.ButtonTypes),
  type: _propTypes["default"].oneOf(["submit", "button"]),
  style: _propTypes["default"].object,
  error: _propTypes["default"].string
};
Button.defaultProps = {
  onClick: function onClick() {
    return true;
  },
  isLoading: false,
  autoFocus: false,
  disable: false,
  buttonStyle: "default",
  type: "button",
  style: {},
  error: ""
};
var _default = exports["default"] = Button;